module.exports = __webpack_public_path__ + "assets/advantage-badge-5ac402.svg";